import { useQuery } from "@apollo/client";
import { GET_ALL_COURSES } from "../../Querys/querys";
import { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import { Course } from "../../interfaces/Course.interface";
import SearcherTableCourse from "./SearcherTableCourse";
//import FiltrarIcon from "../../assets/svg/Filtrar.svg";
import { CourseInfoCard } from "./CourseInfoCard";
import TableCourse from "./TableCourse";
const BodyCourses = ({ viewSquare, viewList, infoImg }: any) => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [course, setCourse] = useState<Course[]>([]);
  const [courseFilter, setCourseFilter] = useState<Course[]>([]);
  const {
    data: cursosInfo,
    loading,
    startPolling,
    stopPolling,
  } = useQuery(GET_ALL_COURSES);
  const cursosPoling = cursosInfo?.GET_ALL_COURSES

  useEffect(() => {
    startPolling(1000)
    return () =>{
    stopPolling()
    }
  }, [cursosPoling,startPolling, stopPolling]); 

  // const filtrar = () => {
  //   const curso = [...courses];
  //   const nuevoFiltrado = curso.sort((x: any, y: any) =>
  //     x.title.localeCompare(y.title)
  //   );
  //   setCourses(nuevoFiltrado);
  // };
  useEffect(() => {
    if (cursosInfo && cursosInfo.GET_ALL_COURSES) {
      if (Object.keys(infoImg).length > 0) {
        const img = { ...infoImg };
        const courses = [...cursosInfo.GET_ALL_COURSES];
        const arrayCourses: any = [];
        courses.map((course) => {
          if (course.id === img.idCurso) {
            const res = { ...course, URL: img.URL };
            arrayCourses.push(res);
          } else {
            arrayCourses.push(course);
          }
        });
        setCourses(arrayCourses);
        setCourseFilter(arrayCourses);
        setCourse(arrayCourses);
      } else {
        setCourses(cursosInfo.GET_ALL_COURSES);
        setCourseFilter(cursosInfo.GET_ALL_COURSES);
        setCourse(cursosInfo.GET_ALL_COURSES);
      }
    }
  }, [cursosInfo, infoImg]);

  useEffect(() => {
    if (courseFilter.length > 0) {
      const orderFilter = [...courseFilter];
      orderFilter.sort((a: any, b: any) => {
        return b.dateAdd - a.dateAdd;
      });
      setCourses(orderFilter);
    } else {
      setCourses(courseFilter);
    }
  }, [courseFilter]);
  return (
    <>
      {loading === true ? (
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
      ) : (
        <Box p={2}>
          <div className="containerBtnFindFilter">
            <div>
              <SearcherTableCourse
                initState={courses}
                setState={setCourseFilter}
                stateInitial={course}
                label="Buscar por curso"
                fields={["titulo"]}
                width={400}
              />
            </div>
            {/* <div className="">
                    <button
                    id="addCurso"
                    onClick={()=>filtrar()}
                    className="btnFiltrar"
                    >
                        <div className="alineacionBoton">
                            <img src={FiltrarIcon} alt="Filtrar"/>
                            <div className="nombreCurso">
                                <b>
                                    <span>Filtrar</span>
                                </b>
                            </div>
                        </div>
                    </button>
                </div> */}
          </div>
          {viewSquare && courses?.length >= 1 ? (
            <Grid className="infoCurso">
              <Grid className="exCont">
                {courses?.map((course: any) => {
                  return <CourseInfoCard key={course.id} course={course} />;
                })}
              </Grid>
            </Grid>
          ) : viewList && courses.length >= 1 ? (
            <Grid>{<TableCourse courses={courses} />}</Grid>
          ) : (
            <Grid container justify="flex-start" className="msjNotFound">
              <span className="msjNotFound2">
                Aún no tienes cursos registrados
              </span>
            </Grid>
          )}
        </Box>
      )}
    </>
  );
};

export default BodyCourses;
